import image1 from "./assets/image1.jpg";
import image2 from "./assets/image2.jpg";
import image3 from "./assets/image3.jpg";
import image4 from "./assets/image4.jpg";
import image5 from "./assets/image5.png";

const data = {
  lengthOfData: 5, //TODO toggle length
  realData: [
    {
      id: 1,
      name: "omosuyi olawole",
      age: 21,
      picture: image1,
    },
    {
      id: 2,
      name: "omosuyi adewole",
      age: 18,
      picture: image2,
    },
    {
      id: 3,
      name: "odebunmi lekan",
      age: 13,
      picture: image3,
    },
    {
      id: 4,
      name: "omosuyi oladele",
      age: 12,
      picture: image4,
    },
    {
      id: 5,
      name: "omosuyi daniel",
      age: 55,
      picture: image5,
    },
  ],
};

export default data;
